module.exports = __webpack_public_path__ + "img/6_pc.6ca434f4.gif";